// modules/invitations/routes.tsx
import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { Spin } from 'antd';
import InvitationManagement from './views/InvitationManagement';
import SelfRegistrationView from './views/SelfRegistrationView';
import MultiStepSelfRegistrationView from './views/MultiStepSelfRegistrationView';
import OfficerReviewView from './views/OfficerReviewView';
import OfficerReviewDetailView from './views/OfficerReviewDetailView';
import OfficerRequestManagementView from './views/OfficerRequestManagementView';
import SelfInvitationForm from './views/SelfInvitationForm';

// Lazy load dashboard and reports views
const SelfRegistrationDashboardView = lazy(() => import('./views/SelfRegistrationDashboardView'));
const SelfRegistrationReportsView = lazy(() => import('./views/SelfRegistrationReportsView'));

// Routes that should be inside MainLayout (authenticated)
export const invitationRoutes: RouteObject[] = [
    {
        path: 'invitations/invite',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <InvitationManagement />
            </Suspense>
        )
    },
    {
        path: 'registration/review',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <OfficerReviewView />
            </Suspense>
        )
    },
    {
        path: 'registration/review/:sessionToken',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <OfficerReviewDetailView />
            </Suspense>
        )
    },
    {
        path: 'registration/request-management',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <OfficerRequestManagementView />
            </Suspense>
        )
    },
    {
        path: 'registration/dashboard',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <SelfRegistrationDashboardView />
            </Suspense>
        )
    },
    {
        path: 'registration/reports',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <SelfRegistrationReportsView />
            </Suspense>
        )
    }
];

// Routes that should be outside MainLayout (public registration)
export const publicInvitationRoutes: RouteObject[] = [
    {
        path: '/register',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <MultiStepSelfRegistrationView />
            </Suspense>
        )
    },
    {
        path: '/register-legacy',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <SelfRegistrationView />
            </Suspense>
        )
    },
    {
        path: '/self-invitation',
        element: (
            <Suspense fallback={<div className="flex items-center justify-center h-screen"><Spin size="large" /></div>}>
                <SelfInvitationForm />
            </Suspense>
        )
    }
];
